import { AxiosError } from "axios";

// Mensagem para o usuário a partir da resposta de erro da API
export const mensagemDeErro = (error: AxiosError<any>): string => {
  const data = error.response?.data;
  if (data?.errors?.length) return data.errors.map((e: any) => e.message).join('\n');
  if (data?.message && data.message !== 'Validation error') return data.message;
  switch (error.response?.status) {
    case undefined: return 'Sem conexão com o servidor. Verifique sua internet e tente novamente.';
    case 401:
    case 403: return 'Você não tem permissão para esta ação.';
    case 404: return 'Registro não encontrado. Ele pode ter sido excluído.';
    case 409: return 'O registro está vinculado a outros cadastros.';
    default: return 'Não foi possível concluir a operação. Tente novamente.';
  }
}
